import React from "react";

const APP_VERSION =
  (typeof process !== "undefined" &&
    process.env &&
    process.env.REACT_APP_VERSION) ||
  "0.1.0";

const AppVersion = () => {
  return (
      <div className="delete-account-container">
        <div className="warning-card">
          <p className="warning-description">
            {APP_VERSION} - Latest Version
          </p>
        </div>
      </div>
  );
};

export default AppVersion;
